import { NgModule } from '@angular/core';

import { TranslatePipe } from './translation.pipe';

/**
 * @deprecated import TranslatePipe instead
 */
@NgModule({
    imports: [TranslatePipe],
    exports: [TranslatePipe]
})
export class TranslationModule {}
